import React from 'react';
import { HiPlus, HiMinus } from 'react-icons/hi';

const ZoomButtons = ({
  cameraMinusZoom,
  cameraPlusZoom,
}: {
  cameraMinusZoom: () => void;
  cameraPlusZoom: () => void;
}) => {
  return (
    <div className="zoom-buttons">
      <div className="minus-button" onClick={() => cameraMinusZoom()}>
        <HiMinus size={25} />
      </div>
      <div className="plus-button" onClick={() => cameraPlusZoom()}>
        <HiPlus size={25} />
      </div>
    </div>
  );
};

export default ZoomButtons;
